<template>
  <div>
    <div class="px-6 pt-4">
      <AlertSichernConnectNotificacion
        :key="sichernConnectAlertColor"
        v-model="showSichernConnectAlert"
        :color="sichernConnectAlertColor"
        :title="sichernConnectAlertTitle"
        :message="sichernConnectAlertMessage"
        :shown-button-close="true"
      />
    </div>
    <div class="p-6" v-if="!isApprover">
      <div class="flex flex-row">
        <div class="flex flex-col md:flex-row">
          <div class="w-full md:w-2/3">
            <div class="flex flex-col md:flex-row w-full">
              <div class="md:w-1/2 p-4">
                <div class=" h-64 bg-white border border-gray-300 rounded p-4">
                  <UserGreeting />
                </div>
              </div>
              <div class="md:w-1/2 p-4">
                <div class="h-64 bg-white border border-gray-300 rounded hover:shadow-xl p-4 cursor-pointer">
                  <DirectTeam :countTeamData="teamData.count" />
                </div>
              </div>
            </div>

            <div class="flex flex-col md:flex-row w-full">
              <div class="md:w-1/2 p-4">
                <div class=" h-64 bg-white border border-gray-300 rounded hover:shadow-xl p-4 ">
                  <SearchDocuments />
                </div>
              </div>
              <div class="md:w-1/2 p-4">
                <div class="h-64 bg-white border border-gray-300 rounded hover:shadow-xl p-4">
                  <SignDocuments :documentsData='documentsData' />
                </div>
              </div>
            </div>
          </div>

          <div class="w-full md:w-1/3">
            <div class="p-4 w-full h-full">
              <PendingTasks />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="p-6" v-else>
      <div class="flex flex-row">
        <div class="flex flex-col md:flex-row">
          <div class="w-full md:w-2/4">
            <div class="flex flex-col md:flex-row w-full">
              <div class="md:w-full p-4">
                <div class=" h-48 bg-white border border-gray-300 rounded p-4">
                  <UserGreeting />
                </div>
              </div>
            </div>
            <div class="flex flex-col md:flex-row w-full">
              <div class="md:w-full p-4">
                <div class="bg-white border border-gray-300 rounded hover:shadow-xl w-full pt-2">
                  <div class="flex ">
                    <div class="flex text-zt-primary-600 p-4 text-lg">
                      <zt-icon name="calendar-2" />
                      <p class="pl-2">{{ $t('message.dashboard.absences') }}</p>
                    </div>
                    <div class="mt-2">
                      <zt-chip outline color="warning" small class="font-medium chip-absent"> <zt-icon
                          name="person-solid" class="pr-1" /> {{ `${teamData.absent_count}
                        ${this.$t("message.menuComponent.licences.upperCase")}` }} </zt-chip>
                    </div>
                  </div>
                  <div class="p-4 flex justify-center" v-if="teamData.count !== 0" :key="reRenderedSings">
                    <doughnut-chart width=150 height=150 data-vs-graph="chartDataSings" :datasets="chartData"
                      ref="canvas" :labels="chartData.labels" :key="reRenderedSings"></doughnut-chart>
                  </div>
                  <div class="flex justify-end text-zt-primary-200 p-4 text-md cursor-pointer"
                    @click="$router.push({ name: 'pendingApproval', params: { showPendingProp: 2, routerGo: 'dashboard' } })"
                    data-vs-button="toPendingApproval">
                    <p class="pl-2">{{ $t("message.menuComponent.seeMissing") }}</p>
                    <zt-icon name="angle-right" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="w-full md:w-3/4">

            <div class="flex flex-col md:flex-row w-full">
              <div class="md:w-1/2 p-4">
                <div class="card-height bg-white border border-gray-300 rounded hover:shadow-xl p-4 cursor-pointer">
                  <DirectTeam :countTeamData="teamData.count" :dashboard='true' />
                </div>
              </div>
              <div class="md:w-1/2 p-4">
                <div class="card-height bg-white border border-gray-300 rounded hover:shadow-xl p-4">
                  <SignDocuments :documentsData='documentsData' :dashboard='true' />
                </div>
              </div>
            </div>
            <div class="flex flex-col md:flex-row w-full">
              <div class="md:w-full p-4">
                <div class="pl-4 h-48 bg-white border border-gray-300 rounded p-4">
                  <template v-if="permissionOnButton('91')">
                    <TeamBalanceReport />
                  </template>
                  <template v-else>
                    <SearchDocuments :dashboard="true" />
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="w-full md:w-2/4">
            <div class="p-4 w-full h-full">
              <PendingTasks />
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="flex flex-col md:flex-row px-6">
      <div class="p-4 w-full md:w-1/3">
        <UpcomingBirthdays />
      </div>
      <div class="p-4 w-full md:w-1/3" v-if="hasVPI">
        <AbsenceToColaborator/>
      </div>
      <div class="p-4 w-full md:w-1/3" v-if="payrollStatusIsActive">
        <SalaryAdvanceToColaborator/>
      </div>
    </div>
    <SichernConnect />
  </div>
</template>

<script>
import Manager from "@/apiClient/Manager"
import PendingTasks from '../pages/PendingTasks.vue'
import UserGreeting from '../components/UserGreeting.vue'
import DirectTeam from '../components/DirectTeam.vue'
import SignDocuments from '../components/SignDocuments.vue'
import UpcomingBirthdays from '../components/UpcomingBirthdays.vue'
import SearchDocuments from '../components/SearchDocuments.vue'
import DoughnutChart from '../components/doughnutChart.vue'
import TeamBalanceReport from '../components/TeamBalanceReport.vue'
import AbsenceToColaborator from '../components/AbsenceToColaborator.vue'
import SalaryAdvanceToColaborator from '../components/SalaryAdvanceToColaborator.vue'
import SichernConnect from '@/components/SichernConnect/SichernConnect.vue'
import AlertSichernConnectNotificacion from '@/components/SichernConnect/AlertSichernConnectNotificacion.vue'
import { mapState, mapActions, mapGetters } from 'vuex'
import { state, mutations } from '../../Licenses/components/Observables/pending'

export default {
  name: "Dashboard",
  provide: { state, mutations },
  components: {
    PendingTasks,
    UserGreeting,
    SearchDocuments,
    DirectTeam,
    SignDocuments,
    UpcomingBirthdays,
    DoughnutChart,
    TeamBalanceReport,
    AbsenceToColaborator,
    SalaryAdvanceToColaborator,
    SichernConnect,
    AlertSichernConnectNotificacion
  },
  data() {
    return {
      teamData: {
        absent_count: 0,
      },
      documentsData: {},
      chartData: {
        labels: this.$t("message.myTeam.chartData").split(","),
        datasets: [
          {
            data: [],
            backgroundColor: ['#54CAA6', '#A3E4D7'],
            hoverBackgroundColor: ['#54CAA6']
          }
        ],
        reRenderedSings: 0
      },
      reRenderedSings: 0,
      dismissedExpiredAlert: false
    }
  },
  async created() {
    this.manager = new Manager();
    await this.setProfile()
    const user = this.getProfile
    this.$store.dispatch('setUser', { user })
    this.$store.dispatch('sichernConnect/requestLinkingStatus')
    await this.getMyTeamStatistics();
  },
  methods: {
    ...mapActions({
      setProfile: 'setProfile'
    }),
    async getMyTeamStatistics() {
      try {
        this.reRenderedSings += 1
        const result = await this.manager.getStatistics();
        const { data } = result.data;
        const { team, documents } = data;
        this.documentsData = documents;
        this.teamData = team
        this.updateChartData(team);
      } catch (error) {
        this.documentsData = {};
        this.teamData = {}
      }
    },
    updateChartData(team) {
      this.chartData.datasets[0].data = [team.attendant_count, team.absent_count];
      this.chartData.attendant_percent = team.attendant_percent
      this.reRenderedSings += 1;
      this.chartData.reRenderedSings += 1
    },
    permissionOnButton(id) {
      const actions = this.$store.state.actions;
      return actions && actions.length > 0 ? actions.some(act => act.id === id) : false;
    }
  },
  computed: {
    ...mapState(['user']),
    ...mapGetters({
      getProfile: 'getProfile'
    }),
    isApprover() {
      return this.user.es_aprobador
    },
    hasVPI() {
      return this.$store.state.hasIntegrationSichernPeople
    },
    payrollStatusIsActive() {
      return  this.$store.state.payrollStatus
    },
    showSichernConnectAlert: {
      get () {
        return this.$store.state.sichernConnect.hasErrorLinking ||
          this.$store.state.sichernConnect.successLinking ||
          (this.$store.state.profile.expired_password && this.$store.getters['sichernConnect/isAlreadyLinked'] && !this.dismissedExpiredAlert)
      },
      set (val) {
        if (!val) {
          if (this.$store.state.sichernConnect.hasErrorLinking) {
            this.$store.commit('sichernConnect/SET_HAS_ERROR_LINKING', false)
          } else if (this.$store.state.sichernConnect.successLinking) {
            this.$store.commit('sichernConnect/SET_SUCCESS_LINKING', false)
          } else {
            this.dismissedExpiredAlert = true
          }
        }
      }
    },
    isSichernConnectError () {
      return this.$store.state.sichernConnect.hasErrorLinking
    },
    sichernConnectAlertColor () {
      if (this.isSichernConnectError) return 'danger'
      if (this.$store.state.sichernConnect.successLinking) return 'success'
      return 'info'
    },
    sichernConnectAlertTitle () {
      if (this.isSichernConnectError) return this.$t('message.sichernConnect.modal.notification.errorTitle')
      if (this.$store.state.sichernConnect.successLinking) return this.$t('message.sichernConnect.modal.notification.successTitle')
      return this.$t('message.sichernConnect.modal.notification.infoPasswordTitle')
    },
    sichernConnectAlertMessage () {
      if (this.isSichernConnectError) return this.$t('message.sichernConnect.modal.notification.errorMessage')
      if (this.$store.state.sichernConnect.successLinking) return this.$t('message.sichernConnect.modal.notification.successMessage')
      return this.$t('message.sichernConnect.modal.notification.infoPasswordMessage')
    }
  },
};
</script>
<style scoped lang="scss">
.card-height {
  height: 21rem;
}
</style>
